/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-29 11:16:34
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-08 14:11:42
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Col,
  notification,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../../transactionQuery/transactionQuerySlice'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { BirthdayQuery } from './birthdayQuery'
import { RootDispatch } from '../../../app/store'
import { getMessageCount, getPatientPage, selectMessageCount } from '../../A-toothModule/toothHome/toothHomeSlice'
import { AGColumns } from './birthdayColumns'
import { getSortColumnList } from '../../../models/common'
import { ThemeContext } from '../../../theme/ThemeContext'
import { SendMessageModal } from '../../A-toothModule/toothHome/modal/sendMessageModal'
import { decrypt } from '../../../models/m'
import { getPatientDetail } from '../../patient/patientSlice'
import { PatientModal } from '../../patient/modals/PatientModal'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'

const BirthdayPage = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const messageCount = useSelector(selectMessageCount)

  const [pageLoading, setPageLoading] = useState(false)

  const [sendMessageModal, setSendMessageModal] = useState(false) // 发送短信弹窗

  const [sendMsgObj, setSendMsgObj] = useState<any>(null)

  const [patient, setPatient] = useState<any>()

  const [isPatientModalVisible, setIsPatientModalVisible] = useState(false)

  const [selectIds, setSelectIds] = useState<any>([])

  const [selectRow, setSelectRow] = useState<any>([])

  // 所有的列表
  const listData: any = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,  // 启用表头复选框（全选功能）
      width: 60,
      minWidth: 60,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'name',
      width: 200,
      minWidth: 200,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '性别',
      field: 'sex',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '年龄',
      field: 'ageYear',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '联系电话',
      field: 'phone',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '出生年月',
      field: 'birthday',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '医生',
      field: 'doctorName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '短信发送时间',
      field: 'smsSendTime',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 120,
      minWidth: 120,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = listData

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [loading, setLoading] = useState(false)

  const [sortedInfo, setSorter] = useState<any>()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [HZGLCKHZSJHData, setHZGLCKHZSJHData] = useState(true)

  const [HZGLCKHZSFZHData, setHZGLCKHZSFZHData] = useState(true)

  // 获取患者管理查看患者手机号数据权限
  const getCheckPermissionFn = () => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.HZGLCKHZSJH }))
      .then(unwrapResult)
      .then((res: any) => {
        setHZGLCKHZSJHData(res)
      })
    // 患者管理查看患者身份证号数据权限
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.HZGLCKHZSFZH }))
      .then(unwrapResult)
      .then((res: any) => {
        setHZGLCKHZSFZHData(res)
      })
  }

  useEffect(() => {
    getCheckPermissionFn()
  }, [])

  const getPage = () => {
    setPageLoading(true)
    dispatch(getPatientPage(params))
      .then(unwrapResult)
      .then((res: any) => {
        const data = {
          total: res.total,
          items: res.records,
        }
        setPage(data)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (params.startTime) {
      getPage()
      getPageColumnList()
    }
  }, [params])

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'birthdayPage',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'birthdayPage',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const disable = (callback: () => void) => {
    if (selectIds.length == 0) {
      notification.info({
        message: '请先选择患者',
      })
      return
    }
    callback()
  }

 useEffect(() => {
    dispatch(getMessageCount())
    return () => {
     setSelectIds([])
     setSelectRow([])
    }
  }, [])

  return (
    <Col
      style={{
        marginTop: 10,
        padding: '20px 15px',
        height: 'calc(100% - 10px)',
        borderRadius: theme.br,
        backgroundColor: theme.pn,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <BirthdayQuery
        loading={pageLoading}
        messageCount={messageCount}
        onSend={() => {
          disable(() => {
            setSendMsgObj(null)
            setSendMessageModal(true)
          })
        }}
        onSubmit={(obj) => {
          setParams({
            ...params,
            ...obj,
            current: 1,
          })
        }}
      />
      <SimpleAgGrid
        page={{
          current: params?.current || 1,
          size: params?.size || 10,
          total: page?.total,
          items: page?.items,
        }}
        column={(AGColumns(
          params?.size * (params?.current - 1),
          (action, t) => {
            if (action == 'send') {
              setSelectIds([])
              setSelectRow([])
              setSendMsgObj({ ...t, phone: t?.phone ? decrypt(t?.phone) : '' })
              setSendMessageModal(true)
            } else if (action == 'patientDetail') {
              dispatch(getPatientDetail(t?.id))
                .then(unwrapResult)
                .then((pateint: any) => {
                  setPatient(pateint)
                  setIsPatientModalVisible(true)
                })
                .catch(() => {
                  // do nothing.
                })
            }
          },
          allColumnList,
          HZGLCKHZSJHData,
        ))?.filter((item: any) => filterSelectList?.includes(item.field))}
        isLoading={loading}
        pagination={true}
        pageKey={'birthdayPage'}
        rowSelection="multiple"
        selectedRowKeys={selectIds}
        getRowId={(data: any) => data.patient?.id?.toString()}
        onRowDoubleClick={(event: any) => {
          const r = event?.data
        }}
        onRowSelected={((selected, node) => {
          const id = node?.data?.id?.toString()
          const data = node?.data
          if (selected) {
            // 去重：仅当 id 不存在时才追加
            if (!selectIds.includes(id)) {
              setSelectIds([...selectIds, id])
              setSelectRow([...selectRow, data])
            }
          } else {
            setSelectIds(selectIds?.filter((item: any) => item !== id))
            setSelectRow(selectRow?.filter((item: any) => item.id !== id))
          }
        })}
        suppressRowClickSelection={true}
        // 配置底部行样式
        getRowStyle={(params) => {
          if (params.node.rowPinned) {
            return {
              fontWeight: 'normal',
              backgroundColor: '#D9F2FF',
            };
          }
          return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
        }}
        onChangePage={(current: any, size: any) => {
          setParams({
            ...params,
            current,
            size,
          })
          setPage({
            ...page,
            current,
            size,
          })
        }}
        onColumnResized={(v: any) => {
          return
        }}
        onColumnMoved={(v) => {
          // setPageLoading(true)
          const sortList = getSortColumnList(allColumnList, v);
          submitPageList(sortList)
          setAllColumnList(sortList)
        }}
        onSortChanged={(sortModel, hasComparator) => {
          if (hasComparator) {
            console.log("sortModel", page?.items, sortModel, hasComparator)
          } else {
            if (sortModel && sortModel.length > 0) {
              setSorter(sortModel?.[0])
            } else {
              setParams({
                ...params,
                createTimeSort: undefined,
                registrationTimeSort: undefined,
                nameSort: undefined,
                patientIdSort: undefined,
              })
            }
          }
        }}
        sortedInfo={sortedInfo ? [sortedInfo] : []}
      />
      <SendMessageModal
        selectedKeys={selectIds}
        HZGLCKHZSJHData={HZGLCKHZSJHData}
        sendMsgObj={sendMsgObj}
        visible={sendMessageModal}
        onCancel={() => {
          setSendMsgObj(null)
          setSendMessageModal(false)
          setSelectIds([])
          setSelectRow([])
        }}
        onOk={() => {
          setSendMsgObj(null)
          getPage()
          getPageColumnList()
          setSelectIds([])
          setSelectRow([])
        }}
        isBirthday={true}
      />
      <PatientModal
        CKHZSJHData={HZGLCKHZSJHData} //患者管理
        CKHZSFZHData={HZGLCKHZSFZHData} //患者管理
        patient={patient}
        visible={isPatientModalVisible}
        onCancel={() => {
          setIsPatientModalVisible(false)
          setPatient({})
        }}
        onOk={() => {
          setPatient({})
          getPage()
          setIsPatientModalVisible(false)
        }}
      />
    </Col>
  )
}

export const BirthdayPages = forwardRef(BirthdayPage)

